/**
 * Provide empty placeholder to define the validation injected rules
 */
export function noValidate() {
  return null;
}
